import { apiClient } from './axios';

import type {
  User,
  CreateUserDto,
  UpdateUserDto,
  UserQuery,
  PaginatedResponse,
} from '@repo/shared-types';

export const usersApi = {
  getUsers: async (query: Partial<UserQuery> = {}) => {
    const response = await apiClient.get<PaginatedResponse<User>>('/users', { params: query });
    return response.data;
  },

  getUser: async (id: string) => {
    const response = await apiClient.get<User>(`/users/${id}`);
    return response.data;
  },

  createUser: async (data: CreateUserDto) => {
    const response = await apiClient.post<User>('/users', data);
    return response.data;
  },

  updateUser: async (id: string, data: UpdateUserDto) => {
    const response = await apiClient.patch<User>(`/users/${id}`, data);
    return response.data;
  },

  deleteUser: async (id: string) => {
    await apiClient.delete(`/users/${id}`);
  },
};
